import { Injectable as e } from "@webmotors/ioc";
import { setMetadata as t } from "./main6.js";
function u(r) {
  const _ = e(r);
  return (o, c, n) => {
    _(o), t(o, "__QUERY__", {
      name: r
    });
  };
}
function Q(r, _, o) {
  t(r, "__QUERY_KEY__", {
    propertyName: _
  });
}
function d(r, _, o) {
  t(r, "__QUERY_FN__", {
    propertyName: _
  });
}
export {
  u as Query,
  d as QueryFn,
  Q as QueryKey
};
